// extracted by mini-css-extract-plugin
export var dropdownButton = "_4h-0";
export var fullWidthDropdownButton = "_4h-1";
export var icon = "_4h-3";
export var iconPlaceholder = "_4h-2";
export var menuItemRow = "_4h-9";
export var separator = "_4h-e";
export var shortcutContainer = "_4h-7";
export var shortcutContainerFilled = "_4h-8";
export var shortcutIconLg = "_4h-6";
export var shortcutIconMd = "_4h-5";
export var shortcutIconSm = "_4h-4";
export var submenuChevron = "_4h-d";
export var submenuDropdown = "_4h-a";
export var submenuTriggerRow = "_4h-b";
export var submenuTriggerRowOpen = "_4h-c";